import Header, { Content, SubHeader } from './Header'

Header.Content = Content

export default Header

export { SubHeader }
